import React, { useEffect, useState } from 'react';
import styles from './WebBannerPlaceholder.module.scss';
import WebBanner from '../WebBanner/WebBanner';
import useBannerData from './useBannerData';
import classNames from 'classnames';
import { api } from '@r-and-a-shared-ui/randa-trpc-client';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';
import { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { hasValue } from '@r-and-a-shared-ui/utils';

export interface WebBannerPlaceholderProps {
  forced_portrait?: boolean;
  selected_web_banners?: any[];
  codename?: string;
  kontentItemId?: string;
}

export function WebBannerPlaceholder({
  forced_portrait,
  selected_web_banners,
  codename,
  kontentItemId,
}: WebBannerPlaceholderProps) {
  const [loadedSelectedWebBanners, setLoadedSelectedWebBanners] = useState<
    any[] | undefined
  >(selected_web_banners);
  const [isDataFetched, setIsDataFetched] = useState<boolean>(true);

  const { data } = api.kontent.itemWithLinkedItems.useQuery({
    codename: isDataFetched ? '' : codename ?? '',
    depthParameter: 3,
  });

  if (hasValue(data)) {
    const mappedCard = kontentAiDataMapping.web_banner_placeholder(
      data as MEMBERSHIP_MODELS.WebBannerPlaceholder,
    );
    setLoadedSelectedWebBanners(mappedCard?.selected_web_banners);
    setIsDataFetched(true);
  }

  useEffect(() => {
    if (
      selected_web_banners?.length &&
      selected_web_banners.some(
        wb =>
          wb?.mobile_image ||
          wb?.portrait_image ||
          wb?.window_image ||
          wb?.link,
      )
    ) {
      return;
    }
    setIsDataFetched(false);
  }, [selected_web_banners, codename]);

  const bannerData = useBannerData(loadedSelectedWebBanners);

  if (!bannerData) return null;

  return (
    <div
      className={classNames(
        styles.wrapper,
        forced_portrait ? styles['wrapper--portrait'] : '',
      )}
      data-kontent-item-id={kontentItemId}
    >
      <WebBanner
        mobile_image={
          bannerData.mobile_image ||
          bannerData.window_image ||
          bannerData.portrait_image
        }
        window_image={
          forced_portrait
            ? bannerData.portrait_image || bannerData.window_image
            : bannerData.window_image || bannerData.portrait_image
        }
        link={bannerData.link}
      />
    </div>
  );
}

export default WebBannerPlaceholder;
